import React from 'react'
import { Form, Button, Modal, Alert } from 'react-bootstrap'
import { firestore } from '../../firebase/firebase-utils'
import KeywordsField from '../../Text-Editor/keywords'
import '../styles.scss'

class PostNews extends React.Component {
    state = {
        modalShow: false,
        keys: [],
        alert: '',
        Author: '',
        Title: '',
        ImgURL: '',
        Content: ''
    }

    render() {

        const postData = (e) => {
            var Author = this.state.Author;
            var Title = this.state.Title;
            var ImgURL = this.state.ImgURL;
            var Content = this.state.Content;
            if (Author === '' || Title === '' || ImgURL === '' || Content === '') {
                this.setState({ alert: 'fill all fields' })
            }
            else {
                this.setState({ alert: '' })
                let current_datetime = new Date()
                let query = Date.now()
                firestore.collection("technews").doc().set({
                    author: Author,
                    title: Title,
                    img: ImgURL,
                    mail: this.props.email,
                    content: Content,
                    posttime: current_datetime.toString(),
                    query: query,
                    authorImg: this.props.userImg,
                    keys: this.state.keys
                })
                    .then(() => {
                        console.log("Document successfully written!");
                        // reseting values
                        this.setState({ Author: '', Title: '', ImgURL: '', Content: '', modalShow: false, keys: [] })
                    })
                    .catch(function (error) {
                        console.error("Error writing document: ", error);
                    });
            }
        }

        const KeywordCall = (list) => {
            if (list !== []) {
                this.setState({ keys: list })
                console.log(this.state.keys)
            }
        }

        const DeleteKey = (e) => {
            //deleting keyword
            var delKey = e;
            if (delKey !== '') {
                var list = this.state.keys;
                list = list.filter(key => key !== delKey)
                this.setState({ keys: list })
            }
        }
        return (
            <>
                <Button className="floatingBtn" onClick={() => this.setState({ modalShow: true })}>+</Button>
                <Modal
                    show={this.state.modalShow}
                    onHide={() => this.setState({ modalShow: false })}
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    style={{ backgroundColor: '#0d3d63' }}>
                    <Modal.Body>
                        <h4>Post News</h4>
                        <br />
                        <Form.Group><Form.Control value={this.state.Author} onChange={(e) => this.setState({ Author: e.target.value })} className="formInputs" type="text" placeholder="Author" maxLength='20' /></Form.Group>
                        <Form.Group><Form.Control value={this.state.Title} onChange={(e) => this.setState({ Title: e.target.value })} className="formInputs" type="text" placeholder="Title" maxLength='100' /></Form.Group>
                        <Form.Group><Form.Control value={this.state.ImgURL} onChange={(e) => this.setState({ ImgURL: e.target.value })} className="formInputs" type="text" placeholder="ImgURL" /></Form.Group>
                        <Form.Group><Form.Control value={this.state.Content} onChange={(e) => this.setState({ Content: e.target.value })} className="formInputs" as="textarea" rows={5} placeholder="Content" /></Form.Group>
                        <KeywordsField placeholder="add keywords one-by-one " callFunction={KeywordCall} delete={DeleteKey} collection="technews" /><br/>
                        {this.state.alert !== '' ?
                            <Alert variant="danger" style={{textAlign:'center'}}>{this.state.alert}</Alert>
                            : null
                        }
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => this.setState({ modalShow: false })}>
                            Close
                </Button>
                        <Button className="submitBtn" onClick={postData}>submit</Button>
                    </Modal.Footer>
                </Modal>
            </>
        )
    }
}

export default PostNews
